<template>
    <!-- height:100% na obou urovnich, at next/ deti (CityNext/WildNext/...) s vlastnim height:100% maji na co navazat - jinak pod jejich kratsim obsahem prosvitalo pozadi rodicovskeho v-main. overflow-y:auto (ne hidden), at delsi obsah muze scrollovat misto tise oriznuti. -->
    <v-card
        v-if="position && position.type"
        class=" indigo lighten-5"
        style="overflow-y: auto; height: 100%;"
    >
        <div
            class="ma-0 pa-0"
            style="overflow: hidden; height: 100%;"
        >
            <StartingNext
                v-if="position.type === positions.START"
            />

            <OakTutorialNext
                v-if="position.type === positions.TUTORIAL_OAK"
                :position="position"
            />

            <CityNext
                v-if="position.type === positions.CITY"
                :trainer-position="position"
            />

            <WildNext
                v-if="position.type === positions.WILD"
                :wild="position.wild"
                :city="position.city"
                :position-id="position.id"
                :trainer-id="position.trainer.id"
            />

            <BattleScreen
                v-if="isBattlePosition"
                :trainer="position.trainer"
                :position="position"
                :fight="position.pokemonFight"
                :obstacle-fight="position.obstacleFight"
                :encounter="position.encounter"
            />

            <TrainerFightWinNext
                v-if="position.type === positions.FIGHT_STADION_TRAINER_WIN"
                :trainer-position="position"
            />

            <MewtwoFightWinNext
                v-if="position.type === positions.MEWTWO_FIGHT_WIN"
                :trainer-position="position"
            />

            <TrainerWildFightWinNext
                v-if="position.type === positions.FIGHT_WILD_TRAINER_WIN"
                :trainer-position="position"
            />

            <LeagueResultNext
                v-if="position.type === positions.LEAGUE_LOSE"
                :trainer-position="position"
            />

            <LeagueResultNext
                v-if="position.type === positions.LEAGUE_WIN"
                :trainer-position="position"
                is-win
            />

            <DungeonWinNext
                v-if="position.type === positions.DUNGEON_WIN"
                :trainer-position="position"
            />

            <DungeonWinNext
                v-if="position.type === positions.DUNGEON_CHALLENGE_WIN"
                :trainer-position="position"
                is-challenge
            />

            <OakNext
                v-if="position.type === positions.OAK"
                :trainer-id="position.trainer.id"
                :city="position.city"
                :position="position"
            />

            <LeagueRegisterNext
                v-if="position.type === positions.LEAGUE_REGISTER"
                :trainer-position="position"
            />

            <LeagueOakNext
                v-if="position.type === positions.LEAGUE_OAK"
                :trainer-position="position"
            />

            <OfficerJenny
                v-if="position.type === positions.OFFICER_JENNY"
                :trainer-id="position.trainer.id"
                :city="position.city"
                :position="position"

            />
        </div>
    </v-card>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {Positions, WildType} from '@/utils/positionEnum';
    import CityNext from '@/components/journey/next/CityNext';
    import DungeonWinNext from '@/components/journey/next/DungeonWinNext';
    import OakNext from '@/components/journey/next/OakNext';
    import LeagueRegisterNext from '@/components/journey/next/LeagueRegisterNext';
    import LeagueOakNext from '@/components/journey/next/LeagueOakNext';
    import LeagueResultNext from '@/components/journey/next/LeagueResultNext';
    import OfficerJenny from '@/components/journey/positions/OfficerJenny';
    import StartingNext from '@/components/journey/next/StartingNext';
    import OakTutorialNext from '@/components/journey/next/OakTutorialNext';
    import TrainerFightWinNext from "@/components/journey/next/TrainerFightWinNext";
    import TrainerWildFightWinNext from "@/components/journey/next/TrainerWildFightWinNext";
    import WildNext from '@/components/journey/next/WildNext';
    import MewtwoFightWinNext from '@/components/journey/next/MewtwoFightWinNext';
    import BattleScreen from '@/components/journey/positions/BattleScreen';

    export default {
        name: "Journey",
        components: {BattleScreen, CityNext, DungeonWinNext, LeagueOakNext, LeagueRegisterNext, LeagueResultNext, OakNext, OakTutorialNext, OfficerJenny, StartingNext, WildNext, MewtwoFightWinNext, TrainerFightWinNext, TrainerWildFightWinNext},
        data() {
            return {
                positions: Positions,
                wildType: WildType,
            }
        },
        computed: {
            ...mapGetters({
                user: 'user/item',
                position: 'journey/position',
                isLoading: 'journey/isLoading',
            }),
            isBattlePosition() {
                if (!this.position) return false;
                return [
                    this.positions.FIGHT, this.positions.FIGHT_TRAINER, this.positions.LEAGUE_FIGHT,
                    this.positions.MEWTWO_FIGHT, this.positions.FIGHT_TEAM_ROCKET,
                    this.positions.DUNGEON, this.positions.DUNGEON_CHALLENGE,
                    this.positions.WILD_OBSTACLE, this.positions.ENCOUNTER,
                ].includes(this.position.type);
            },
        },
      methods: {
        ...mapActions('journey', [
          'loadPosition',
          'reset',
        ]),
        ...mapActions({
          trainerInfoMessages: 'trainer/loadInfoMessages',
        }),
      },
      created() {
        this.reset();
        if (this.user && this.user.position && this.user.position.id !== undefined) {
          this.loadPosition(this.user.position.id);
        }
      },
    }
</script>

